import React, { useState } from "react";
import "./ProgramHighlights.css";
import { Container } from "react-bootstrap";
import RegistrationPopup from "../registrationPopUp/RegistrationPopup";
import { Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next"; // ✅ import i18n

const ProgramHighlights = ({ cardsData, color = "#E2F3D1" }) => {
  const [flipped, setFlipped] = useState(Array(cardsData.length).fill(false));
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation(); // ✅ i18n hook

  const handleClick = (index) => {
    setFlipped((prev) => {
      const updated = [...prev];
      updated[index] = !updated[index];
      return updated;
    });
  };

  return (
    <section className="program-highlights mt-5">
      <h2>{t("program_highlights_title")}</h2>
      <div className="ph-card">
        <div className="ph-cards-container">
          {cardsData.map((card, index) => (
            <div
              key={index}
              className="ph_card"
              onClick={() => handleClick(index)}
            >
              <div
                className={`ph-card-inner ${flipped[index] ? "flipped" : ""}`}
              >
                <div className="card-front">
                  <img src={card.img} alt={t(card.title)} />
                  <h3>{t(card.title)}</h3>
                </div>
                <div className="card-back" style={{ backgroundColor: color }}>
                  <h4 className="ph-card-title">{t(card.title)}</h4>
                  <div className="green-line"></div>
                  <p>{t(card.details)}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="ph-btns my-5 last-sec">
        <button className="btn btn-ph-Apply" onClick={() => setIsModalOpen(true)}>
          {t("apply_now")} 
        </button>
        <button
          className="btn btn-ph-Questions ms-3"
          onClick={() => navigate("/contact-us")}
        >
          {t("ask_questions")} 
        </button>
      </div>

      <Modal
        open={isModalOpen}
        footer={null}
        destroyOnClose
        onCancel={() => setIsModalOpen(false)}
        width={"80vw"}
      >
        <RegistrationPopup setIsModalOpen={setIsModalOpen} />
      </Modal>
    </section>
  );
};

export default ProgramHighlights;
